<template>
  <v-content class="mainContainer blaStripeBg blaPackagesContainer">
    <div v-if="isLoggedIn === null">
      <Header login-button-color="#f05657" />
    </div>
    <div v-else>
      <Navbar />
    </div>
    <Packages />
    <div v-show="isLoggedIn === null">
      <Footer />
    </div>
  </v-content>
</template>

<style scoped>
@import "../../assets/css/bla_style.css";
</style>

<script>
import Packages from '@/components/Packages';
import Navbar from '@/views/Navbar';
import Footer from '@/views/public/partials/Footer';
import Header from '@/views/public/partials/Header';

export default {
  components: {
    Header,
    Footer,
    Navbar,
    Packages
  },
  data: () => ({
    isLoggedIn: null
  }),
  method: () => ({}),
  mounted() {
    this.isLoggedIn = this.$store.getters.isLoggedIn;
  }
};
</script>
